module.exports = __webpack_public_path__ + "1b4a7bd78ec27a29388b1d8598f20778.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/NonAuthHomePage/components/Banner/components/Background/images/cloud2.svg
// module id = 6kvy
// module chunks = 13